import { Icon, SectionHeading, Typography } from '@modulor/react';
import styles from './styles.module.css';
import { Local } from '../../../Local/Local';
import SeoLink from '../../../SeoLink/SeoLink';
import { SLOTS } from '../../../../constants/productTypes';
import type { ReactNode } from 'react';

type NavigationListHeaderProps = {
  title: ReactNode;
  onAllClick: () => void;
  url: string;
};

const NavigationListHeader = ({
  title,
  onAllClick,
  url,
}: NavigationListHeaderProps) => {
  return (
    <SectionHeading noPadding className={styles.heading}>
      <Typography variant={'caption-1-regular-caps'}>{title}</Typography>
      <SeoLink productType={SLOTS} url={url}>
        <span className={styles.all} onClick={onAllClick}>
          <Typography variant={'body-regular'} className={styles.allText}>
            <Local>All</Local>
          </Typography>
          <Icon name={'chevron-right'} className={styles.chevron} size={20} />
        </span>
      </SeoLink>
    </SectionHeading>
  );
};
export default NavigationListHeader;
